export default {
    appName: process.env.VUE_APP_APP_NAME,
}
